import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import App from "./App.tsx";
import "./index.css";

// Initialize Sentry for error tracking and performance monitoring
Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN || "https://9c64c9e5addfd78cdeb4c47f542d4846@o4510515157598208.ingest.us.sentry.io/4510515235651584",
  environment: import.meta.env.MODE,
  
  // Performance monitoring
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: true,
      blockAllMedia: true,
    }),
  ],
  
  // Performance sample rate (adjust based on traffic)
  tracesSampleRate: import.meta.env.PROD ? 0.1 : 1.0,
  
  // Session replay sample rate
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  
  // Only send errors in production, or if DSN is set in dev
  enabled: !!import.meta.env.VITE_SENTRY_DSN,
  
  // Filter out noisy errors
  ignoreErrors: [
    // Browser extensions
    "top.GLOBALS",
    "ResizeObserver loop",
    // Network errors
    "Network request failed",
    "Failed to fetch",
    "Load failed",
    // User aborted
    "AbortError",
  ],
  
  // Add release version for source map matching
  release: import.meta.env.VITE_SENTRY_RELEASE || undefined,
});

createRoot(document.getElementById("root")!).render(<App />);
